<template>
  <section>
    <div class="Product_category">
      <div class="stage-1">
        <p class="firstLine">
          <span @click="backButton" style="cursor: pointer;">
            <i class="fas fa-arrow-left" style="font-size:10px;"></i>
          </span>
<!--          <span class="salesman-text">{{salesData[0].dim1_name}}</span>-->
        </p>
        <div class="timePeriod">
          <p
              class="options" @click="updateTimePeriod('MTD')"
              :class="{ 'selected': localSelectedVal=== 'MTD' }">
            MTD
          </p>
          <p
              class="options" @click="updateTimePeriod('QTD')"
              :class="{ 'selected': localSelectedVal === 'QTD' }">
            QTD
          </p>
          <p
              class="options" @click="updateTimePeriod('YTD')"
              :class="{ 'selected': localSelectedVal === 'YTD' }">
            YTD
          </p>
          <template v-if="isFirstDayOfMonth">
          <p
              class="options" @click="updateTimePeriod('PMTD')"
              :class="{ 'selected': localSelectedVal=== 'MTD' }">
            PMTD
          </p>
          <p
              class="options" @click="updateTimePeriod('PQTD')"
              :class="{ 'selected': localSelectedVal === 'PQTD' }">
            PQTD
          </p>
          <p
              class="options" @click="updateTimePeriod('PYTD')"
              :class="{ 'selected': localSelectedVal === 'PYTD' }">
            PYTD
          </p>
          </template>
          <p class="options">
            <DatePicker
                v-model="dateRange"
                :class="{ 'selected': this.localSelectedVal === 'Date Range' }"
                :multiple="true"
                :confirm="true"
                :disabled-date="disableFutureDates"
                :show-input="false"
                :enable-time-picker="false"
                :clearable="false"
                :style="datepickerStyle"
            />
          </p>
        </div>
      </div>
      <p class="secondLine" v-if="localSelectedVal==='Date Range'">From
        {{ new Date(dateRange[0]).toLocaleDateString('en-GB') }}
        To {{ new Date(dateRange[dateRange.length - 1]).toLocaleDateString('en-GB') }}
      </p>
      <div class="product_details">
        <select v-model="selectedProduct" class="customSelect">
          <option v-for="(item,index) in aggregatedData" :key="index" :value="item">
            {{ item.dim2_name }}
          </option>
        </select>
      </div>

      <div class="title">
        <div class="secondRow">
          <div class="category" @click="toggleDropdown">
            <div class="dropdown">
              <span v-if="openIndexes" class="dropdown_image_color" style="margin-left: 10px">▲</span>
              <span v-else style="margin-left: 10px">▼</span>
            </div>
            <div class="num">{{ segregatedData[0].dim2_name}}</div>
            <span class="total-quantity">{{ segregatedData.length }}</span> <!-- Adjusted class for total quantity -->
          </div>

          <div class="dropdown-content mt-[-10px]" v-if="openIndexes">
            <div>
              <div class="list_item" v-for="(data, i) in segregatedData" :key="i">
                <div class="">{{ data.dim5_name }}</div>
                <div class="ml-auto">{{ data.metric1 }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="updateDate">-->
<!--      <p>*Last updated on {{ new Date() }}</p>-->
<!--    </div>-->
  </section>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import axios from "axios";

export default {
  name: "ProductCategory",
  components: {DatePicker},
  props: {
    salesData :[],
    selectedVal: String,
    page1Flag:Boolean,
    dateSelected:null,
    storeCode:String,
    aggregatedData:Array,
    viz1:Object,
    filters:Object,
    selectedDataSql:Object
  },
  data: () => ({
    salesDate: [],
    allProducts: [],
    filteredRecords: [],
    selectedProduct: [],
    datepickerStyle: {
      '--dp-background-color': '#E4E5F9',
      '--dp-icon-color': '#083DB1',
    },
    dateRange: null,
    today: new Date(),
    year: new Date().getFullYear(),
    preYear: new Date().getFullYear() - 1,
    month: new Date().getMonth() + 1,
    monthName: new Intl.DateTimeFormat('en-US', {month: 'long'}).format(new Date()),
    openIndexes: false,
    localSelectedVal: "", // Local data property to mirror the prop
    localSalesData:[]
}),
  computed: {
    isFirstDayOfMonth() {
      const today = new Date();
      return today.getDate() === 1; // Returns `true` only on the 1st day of the month
    },
    segregatedData() {
      // Use selected product's dim2_name if available, otherwise fall back to storeCode
      const currentStore = this.selectedProduct?.dim2_name || this.storeCode;
      console.log("currentStore",currentStore,this.localSalesData);

      let filteredData = [];

      switch (this.localSelectedVal) {
        case 'MTD': {
          filteredData = this.localSalesData.filter(item =>
              item.dim6_name === 'mtd' &&
              item.dim2_name === currentStore
          );
          break;
        }
        case 'QTD': {
          filteredData = this.localSalesData.filter(item =>
              item.dim6_name === 'qtd' &&
              item.dim2_name === currentStore
          );
          break;
        }
        case 'YTD': {
          filteredData = this.localSalesData.filter(item =>
              item.dim6_name === 'ytd' &&
              item.dim2_name === currentStore
          );
          break;
        }
        case 'PMTD': {
          filteredData = this.localSalesData.filter(item =>
              item.dim6_name === 'pmtd' &&
              item.dim2_name === currentStore
          );
          break;
        }
        case 'PQTD': {
          filteredData = this.localSalesData.filter(item =>
              item.dim6_name === 'pqtd' &&
              item.dim2_name === currentStore
          );
          break;
        }
        case 'PYTD': {
          filteredData = this.localSalesData.filter(item =>
              item.dim6_name === 'pytd' &&
              item.dim2_name === currentStore
          );
          break;
        }
        case 'Date Range': {
          filteredData = this.localSalesData.filter(item =>
              item.dim2_name === currentStore
          );
          break;
        }
      }

      // Get unique combinations of dim3_name and metric3
      // const uniqueData = filteredData.reduce((acc, current) => {
      //   const exists = acc.some(item =>
      //       item.dim5_name === current.dim5_name &&
      //       item.metric1 === current.metric1
      //   );
      //   if (!exists) {
      //     acc.push(current);
      //   }
      //   return acc;
      // }, []);

      console.log("Unique filtered data:", filteredData);
      return filteredData;
    }
  },
watch: {
  storeCode: {
    immediate: true, // Run immediately on component creation
    handler(newStoreCode) {
      if (newStoreCode && this.aggregatedData.length) {
        // Find the product matching the storeCode
        const foundProduct = this.aggregatedData.find(
            item => item.dim2_name === newStoreCode // or whichever field matches storeCode
        );

        if (foundProduct) {
          this.selectedProduct = foundProduct;
        }
      }
    }
  },
  // Watch for when aggregatedData is loaded
  aggregatedData: {
    immediate: true,
    handler(newData) {
      if (this.storeCode && newData.length) {
        // Find the product matching the storeCode
        const foundProduct = newData.find(
            item => item.dim2_name === this.storeCode // or whichever field matches storeCode
        );

        if (foundProduct) {
          this.selectedProduct = foundProduct;
        }
      }
    }
  },
  selectedVal(newVal)
  {
    this.localSelectedVal = newVal; // Update local property when prop changes
  },
  dateRange(newRange)
  {
    console.log("dateRange", newRange);
    if (newRange && newRange.length === 2) {
      this.localSelectedVal = 'Date Range';
      this.updateDatePickerStyle();
      this.getDateRange();
    }
  },
  salesData: {
    immediate: true, // Run immediately on component creation
    deep: true,     // Watch for nested changes if needed
    handler(newVal) {
      // Only update if we have new data
      if (newVal && newVal.length) {
        this.localSalesData = [...newVal];
      }
    }
  },
},
  mounted() {
    this.localSelectedVal = this.selectedVal || 'MTD'; // Set from prop when component loads
    console.log("localSelectedVal", this.localSelectedVal);
    this.dateRange = this.dateSelected
  },
methods: {
  toggleDropdown()
  {
    console.log("toggle called",this.openIndexes)
    this.openIndexes= !this.openIndexes;
  },
  updateTimePeriod(period)
  {
    this.localSelectedVal = period;
    this.updateDatePickerStyle();
    console.log("salesData",this.salesData);
    console.log("selected time period:", this.localSelectedVal);
  },
  updateDatePickerStyle()
  {
    if (this.localSelectedVal === 'Date Range') {
      this.datepickerStyle['--dp-background-color'] = '#083DB1';
      this.datepickerStyle['--dp-icon-color'] = 'white';
    } else {
      this.datepickerStyle['--dp-background-color'] = '#E4E5F9';
      this.datepickerStyle['--dp-icon-color'] = '#083DB1';
    }
  },
  disableFutureDates(date)
  {
    const today = new Date();
    return date > today;
  },
  backButton(){
    this.$emit('update:page1Flag', true);
  },
  formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  },
  getDateRange() {
    const [fromDate, toDate] = this.dateRange;

    // Safely get the first dim2_name from sub_data_sql
    const firstDimName = this.viz1.viz_specific7.sub_data_sql
        ? Object.values(this.viz1.viz_specific7.sub_data_sql)[0]?.dim2_name
        : 'default_dim_name'; // Provide a fallback

    const payload = {
      DateConfig: {
        dateField: [this.viz1.viz_specific7?.dateField],
        dynamicField: ['&dynamic_col1'],
        dimensionField: [this.selectedDataSql?.dim2_name || firstDimName],
        dateRange: {
          fromDate: this.formatDate(fromDate),
          toDate: this.formatDate(toDate)
        }
      }
    };

    let passedParam = {...this.filters,...payload};

    // Safely get the date_range_sql_id
    const datasql = this.viz1.viz_specific7?.date_range_sql_id || 'default_sql_id';
    const url = '/api/fetchDataWithParam/' + datasql + '/' + 'CommonVizClass';

    axios.post(url, passedParam).then(resp => {
      this.$set(this, 'localSalesData', resp.data);
    }).catch(error => {
      console.error("API Error:", error);
    });
  }
}
}
;
</script>

<style scoped>
.Product_category {
  display: flex;
  flex-direction: column;
  width: 95%;
  max-width: 1200px;
  background-color: aliceblue;
  margin: 0 auto;
  border-radius: 30px;
  padding: 15px 10px;
  box-sizing: border-box;
}

.firstLine {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 15px;
  font-size: clamp(16px, 4vw, 20px);
  font-weight: 500;
  color: #083DB1;
  margin: 5px 0 10px;
  width: 100%;
}

.salesman-text {
  flex-grow: 1;
  text-align: center;
  padding: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.secondLine {
  font-size: clamp(14px, 3vw, 16px);
  color: black;
  font-weight: 500;
  margin-bottom: 10px;
  text-align: center;
  width: 100%;
  padding: 0 10px;
}

.timePeriod {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  padding: 0 10px;
  margin-bottom: 10px;
}

.options {
  display: flex;
  height: 36px;
  background-color: #E4E5F9;
  color: #083DB1;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: clamp(12px, 3vw, 14px);
  min-width: 70px;
  flex-grow: 1;
  max-width: 100px;
  transition: all 0.2s ease;
}

.options.selected {
  background-color: #083DB1;
  color: white;
}

.product_details {
  height: 45px;
  background-color: #083DB1;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  border-radius: 10px;
  margin: 5px auto 0;
  width: 95%;
  max-width: 520px;
}

.customSelect {
  background-color: transparent;
  color: white;
  width: 100%;
  border: none;
  cursor: pointer;
  font-size: clamp(14px, 3vw, 16px);
  padding: 5px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 5px center;
  background-size: 15px;
}

.customSelect option {
  background-color: white;
  color: #083DB1;
}

.title {
  display: flex;
  flex-direction: column;
  width: 95%;
  max-width: 520px;
  margin: 0 auto;
}

.firstRow {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: clamp(20px, 5vw, 43px);
  padding: 15px 15px 0 0;
}

.model {
  text-align: center;
  color: #3164f4;
  font-size: clamp(14px, 3vw, 16px);
  font-weight: 600;
  white-space: nowrap;
}

.secondRow {
  width: 100%;
}

.category {
  height: 35px;
  display: flex;
  background-color: #c8edfd;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  border-radius: 10px;
  margin: 15px auto;
  box-shadow: 0 2px 4px rgba(8, 61, 177, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  width: 95%;
}

.category:hover {
  transform: scale(1.01);
  box-shadow: 0 8px 15px rgba(8, 61, 177, 0.5);
}

.category:active {
  transform: scale(0.98);
}

.dropdown {
  color: #3164f4;
  font-size: clamp(14px, 3vw, 18px);
  margin-top:-25px
}

.num {
  color: black;
  font-size: clamp(14px, 3vw, 18px);
  font-weight: 600;
  flex-grow: 1;
  padding: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.total-quantity {
  color: black;
  font-size: clamp(14px, 3vw, 16px);
  font-weight: 600;
}

.dropdown-content {
  display: flex;
  justify-content: flex-end;
  margin-top: -15px;
  width: 100%;
}

.list_item {
  display: flex;
  justify-content: space-between;
  width: 90%;
  max-width: 400px;
  //padding: 5px 15px 5px 0;
  margin: 5px auto;
  font-size: clamp(14px, 3vw, 16px);
}

.updateDate {
  margin: 10px auto 0;
  text-align: center;
  width: 100%;
  color: gray;
  font-size: clamp(12px, 3vw, 14px);
}

/* Very small screen adjustments */
@media (max-width: 400px) {
  .firstLine {
    padding: 5px 10px;
  }

  .options {
    min-width: 60px;
    height: 32px;
  }

  .product_details {
    height: 40px;
  }

  .category {
    height: 30px;
  }

  .num, .total-quantity {
    font-size: 13px;
  }

  .list_item {
    //flex-direction: column;
    gap: 5px;
  }
}


</style>